import styled, { css } from 'styled-components';
import { ReactComponent as MicIcon } from '../../../../assets/icons/mic-icon.svg';

const Container = styled.div`
  display: flex;
  align-self: ${({ $alignment }) => ($alignment)};
  align-items: center;
  justify-content: end;
  width: fit-content;
  padding: 2px 0;

  ${({ $isDisabled }) => $isDisabled && css`
    opacity: 0.3;
    
    * {
      cursor: not-allowed !important;
    }
  `}
`;

const StyledMicIcon = styled(MicIcon)`
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

export {
  Container,
  StyledMicIcon,
};
